
<div class="background-overlay">
  <div class="content-modal">
    <div class="modal-content">
      <div class="description-outer">
      <div (click)="backToHome()" class="description-container close-position">
        <span class="close-text" [theme]="themeOptions">{{'close' | translate }}</span>
        <img
        src="/assets/images/wj_Icon_24_Close.svg"
        data-qa="close-button"
        class="close"
        aria-label="close"
      />
      </div>
      </div>
      <div class="access" [theme]="themeOptions"> 
        <h1>{{'orders-in-progress' | translate}}</h1>
        <p>{{'in-progress-explanation' | translate }}</p>
        <ng-container *ngIf="guestsInActiveOrders > 0">{{guestsInActiveOrders}} {{'inprogress-table-status' | translate }} ({{ 'last-checked' | translate}}: {{lastCheck}})</ng-container>
        
        
      </div>


      <div class="btn-container">
        <button *ngIf="!readyForMore" type="button" [theme]="themeOptions" (click)="checkStatusNow()"  class="btn-primary">{{ 'check-in-progress-orders' | translate}}</button>
        <button *ngIf="readyForMore" type="button" [theme]="themeOptions" (click)="toTheMenu()"  class="btn-primary">{{ 'ready-for-next-order' | translate}}</button>
        <progress *ngIf="checkingStatus" id="progress-bar" aria-label="{{'processing' | translate}}" ></progress>
      </div>
    </div>
  </div>
</div>